export const POPULATE_SESSION = 'populateSession';
export const OTHER = 'other';




// WEBPACK FOOTER //
// ./src/store/modules/session/mutation-types.js